export default {
  apartments: {
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbSolutions: 'Zgjidhjet',
    breadcrumbCurrent: 'Pallatet dhe pronat',
    hero: {
      eyebrow: 'Pallatet dhe pronat',
      title: 'Siguri për ndërtesa të tëra banimi',
      lead: 'Hyrja, shkallët, garazhi nëntokësor – planifikojmë mbikëqyrje për pallatet që mbron qiramarrësit dhe u jep qetësi pronarëve.',
    },
    areas: {
      title: 'Pikat e mbikëqyrjes në pallat',
      lead: 'Zonat e përbashkëta janë pikat më të rëndësishme të nisjes. Respektojmë gjithmonë të drejtat e të gjithë banorëve.',
      items: {
        '0': { title: 'Hyrja e ndërtesës', desc: 'Hyrja është kartëvizita e ndërtesës dhe pika më e rëndësishme e mbikëqyrjes. Kamerat kapin kush hyn.' },
        '1': { title: 'Shkallët', desc: 'Shkallët janë kalime me shumë lëvizje. Kamera kompakte i mbyllin boshllëqet mes kateve pa u ndjerë.' },
        '2': { title: 'Bodrumi i biçikletave', desc: 'Biçikletat dhe e-biçikletat janë objektiva të zakonshëm vjedhjeje. Mbikëqyrja parandalon dhe ndihmon në sqarim.' },
        '3': { title: 'Zonat e jashtme', desc: 'Këndet e lojërave, gjelbërimi dhe shtigjet janë të përbashkëta. Kamera rezistente mbrojnë edhe këtu.' },
        '4': { title: 'Garazhi nëntokësor', desc: 'Vendet e garazhit nëntokësor janë të rrezikuara natën. Mbikëqyrja e ndriçuar mirë sjell siguri.' },
        '5': { title: 'Kutitë postare', desc: 'Kutitë postare dhe ndarjet e pakove janë qendra e vjedhjes së pakove. Kamerat e hyrjes ndihmojnë shumë.' },
      },
    },
    protection: {
      eyebrow: 'Mbrojtja e të dhënave dhe rregullorja',
      title: 'Mbikëqyr pa cenuar',
      lead: 'Në një pallat kryqëzohen shumë interesa. E zbatojmë mbikëqyrjen që respekton privatësinë e banorëve dhe mbetet ligjore.',
      items: {
        '0': { title: 'Maskimi i zonave private', desc: 'Dritaret, dyert e banesave dhe zonat private fshihen teknikisht – mbeten vetëm zonat e përbashkëta.' },
        '1': { title: 'Vendimi dhe rregullorja', desc: 'Mbikëqyrja me video në pallat kërkon një bazë të qëndrueshme. Ju mbështesim në zbatim të pastër.' },
        '2': { title: 'Tabelat informuese', desc: 'Njoftime të qarta në hyrje informojnë qiramarrësit dhe vizitorët – në mënyrë transparente e të drejtë.' },
      },
    },
    value: {
      eyebrow: 'Vlerë e shtuar',
      title: 'Përparësi për pronarët dhe administratorët',
      lead: 'Një sistem i menduar mirë u shërben të gjithëve: qiramarrësit ndihen më të sigurt, pronarët mbrojnë pasurinë dhe administratorët fitojnë qartësi.',
      list: {
        '0': 'Qasje për administratorët dhe pronarët me të drejta të ndara',
        '1': 'Regjistrim i ditëve deri javëve të fundit – sipas konfigurimit',
        '2': 'Lehtësim i administrimit në incidente e mosmarrëveshje',
        '3': 'Dokumentim i plotë te vandalizmi apo thyerja',
        '4': 'Parandalim i hyrjeve të paautorizuara',
        '5': 'Ndjenjë më e madhe sigurie për qiramarrësit dhe pronarët',
      },
      note: 'Shënim: ligjshmëria e mbikëqyrjes në ndërtesat e banimit varet shumë nga rasti. Ne ju këshillojmë, pa zëvendësuar këshillën ligjore.',
    },
    cta: {
      title: 'Më shumë siguri për ndërtesën tuaj',
      lead: 'Këshillojmë bashkësitë e pronarëve dhe administratorët pa detyrim – nga ideja e parë te sistemi gati.',
      primary: 'Rezervoni një takim konsultimi',
      secondary: 'Nisni planifikuesin e kamerave',
    },
  },
};